import { Box, Button, FormControlLabel, Switch, TextField, Tooltip, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { convertDecimalToFraction, convertFractionToDecimal } from "../helpers/maths";

const FractionalCalculator = () => {
    const [fraction, setFraction] = useState("");
    const [isDecimalMode, setIsDecimalMode] = useState(false);
    const [result, setResult] = useState(0.0);
  
    useEffect(() => {
      const calculateFraction = () => {
        if (isDecimalMode) {
          const decimal = parseFloat(fraction);
          if (!isNaN(decimal)) {
            return convertDecimalToFraction(decimal);
          }
        } else {
          return convertFractionToDecimal(fraction);
        }
        return 0.0;
      };
      setResult(calculateFraction());
    }, [fraction, isDecimalMode]);
  
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "8px",
          width: "600px",
        }}
      >
        <div style={{ display: "flex", gap: 20, alignItems: "center" }}>
          <Typography variant="h4" gutterBottom>
            Fractional Calculator
          </Typography>
          <FormControlLabel
            control={
              <Switch
                checked={isDecimalMode}
                onChange={() => setIsDecimalMode(!isDecimalMode)}
              />
            }
            label="Decimal to Fraction"
          />
        </div>
        <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <TextField
            label={isDecimalMode ? "Decimal" : "Fraction"}
            variant="outlined"
            value={fraction}
            onChange={(event) => setFraction(event.target.value)}
          />
          <p>= {result}</p>
          {!isDecimalMode && (
            <Button
              onClick={() => {
                navigator.clipboard.writeText(result);
              }}
            >
              <Tooltip title="Copy Decimal">
                <ContentCopyIcon />
              </Tooltip>
            </Button>
          )}
        </Box>
      </div>
    );
  };
  
  export { FractionalCalculator };
